import { render, staticRenderFns } from "./Pmbs.vue?vue&type=template&id=262171f1&scoped=true&lang=pug&"
import script from "./Pmbs.vue?vue&type=script&lang=ts&"
export * from "./Pmbs.vue?vue&type=script&lang=ts&"
import style0 from "./Pmbs.vue?vue&type=style&index=0&id=262171f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262171f1",
  null
  
)

export default component.exports